<div class="relative w-full z-50">
  <div
    class="relative flex items-center rounded-xl border border-slate-200 bg-white shadow-sm transition-all focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-100">
    <input type="text" id="findArticle" [name]="name" [placeholder]="placeholder" [(ngModel)]="parentVal"
      (ngModelChange)="onModif($event)" #newHero (keyup.enter)="keyenter(newHero.value)" (focus)="focusFunction()"
      (blur)="handleBlur()"
      class="w-full bg-transparent px-4 py-2.5 text-sm text-slate-800 placeholder-slate-400 outline-none"
      autocomplete="off" />

    <button *ngIf="parentVal" type="button" (click)="clearInput()"
      class="mr-3 flex h-6 w-6 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
        class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <div *ngIf="isOpen" (mousedown)="$event.preventDefault()"
    class="absolute left-0 z-50 mt-2 w-full min-w-[550px] max-h-[480px] overflow-hidden rounded-xl border border-slate-100 bg-white shadow-xl flex flex-col">
    <div *ngIf="!exist" class="flex items-center justify-center py-8">
      <div class="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-indigo-600"></div>
    </div>

    <div *ngIf="exist" class="flex flex-col text-sm text-slate-700">

      <div class="overflow-y-auto max-h-[420px]">
        <div
          class="sticky top-0 z-10 grid gap-2 bg-slate-50 border-b border-slate-200/80 px-4 py-3 font-semibold text-slate-500 text-xs uppercase tracking-wider"
          [style.grid-template-columns]="gridTemplateColumns">
          <div *ngFor="let item of tbrecherche" class="truncate">
            {{ item.TableRD_Des }}
          </div>
        </div>

        <div class="divide-y divide-slate-100">
          <div *ngFor="let row of items" (click)="selectRow(row)"
            class="grid gap-2 items-center px-4 py-3 hover:bg-indigo-50/60 cursor-pointer transition-colors duration-150"
            [style.grid-template-columns]="gridTemplateColumns">

            <div *ngFor="let item of tbrecherche" class="truncate flex items-center">

              <ng-container *ngIf="isImageColumn(item); else textCell">
                <div class="relative w-10 h-10 rounded-md overflow-hidden bg-slate-100 flex-shrink-0">
                  <img *ngIf="row[item.TableRD_Champs]" [src]="getImageUrl(row)" [alt]="getAltArticle(row)"
                    onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'"
                    class="w-full h-full object-cover" />
                  <div class="w-full h-full items-center justify-center text-base opacity-40"
                    [style.display]="row[item.TableRD_Champs] ? 'none' : 'flex'">📦</div>
                </div>
              </ng-container>

              <ng-template #textCell>
                <span class="truncate text-slate-700 font-medium">{{ row[item.TableRD_Champs] }}</span>
              </ng-template>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>